import {  useQuery,useQueryClient,useMutation  } from '@tanstack/react-query';
import { createCoupon,fetchCouponDetails,updateCoupon,fetchCoupons,deleteCoupon } from './coupons.api';

  export const useCoupons = () => {
    return useQuery({
      queryKey: ['all-coupons'],
      queryFn: async () => {
        const response = await fetchCoupons();
        return Array.isArray(response) ? response : []; 
      },
      keepPreviousData: true,
    });
  };
  
  export function useCouponDetails(couponid) {
    return useQuery({
      queryKey: ['coupon-details', couponid],
      queryFn: () => fetchCouponDetails(couponid),
      enabled: !!couponid 
    });
  }

  export const useCreateCoupon = (onSuccess, onError) => {
    return useMutation({
      mutationFn: createCoupon,
      onSuccess,
      onError,
    });
  };

  export const useUpdateCoupon = (onSuccess, onError) => {
    return useMutation({
      mutationFn: updateCoupon,
      onSuccess,
      onError,
    });
  };
  
  export const useDeleteCoupon = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: deleteCoupon,
      onSuccess: () => {
        queryClient.invalidateQueries(['all-coupons']); // Refetch list after delete
      },
    });
  };
